export const REQUEST_GET_USER_PROFILE = 'userProfile/requestGetUserProfile';
export const REQUEST_GET_USER_PROFILE_START = 'userProfile/requestGetUserProfileStart';
export const REQUEST_GET_USER_PROFILE_COMPLETE =
  'userProfile/requestGetUserProfileCompleted';
export const REQUEST_GET_USER_PROFILE_ERROR = 'userProfile/requestGetUserProfileError';

export const UPDATE_PROFILE_INFO = 'userProfile/updateProfileInfo';
export const UPDATE_PROFILE_INFO_START = 'userProfile/updateProfileInfoStart';
export const UPDATE_PROFILE_INFO_COMPLETE = 'userProfile/updateProfileInfoCompleted';
export const UPDATE_PROFILE_INFO_ERROR = 'userProfile/updateProfileInfoError';

export const SUBMIT_COMPLAINT = 'userProfile/submitComplaint';
export const SUBMIT_COMPLAINT_START = 'userProfile/submitComplaintStart';
export const SUBMIT_COMPLAINT_COMPLETE = 'userProfile/submitComplaintCompleted';
export const SUBMIT_COMPLAINT_ERROR = 'userProfile/submitComplaintError';

export const SUBMIT_FINCH_ACCESS_TOKEN = 'userProfile/submitFinchAccessToken';
export const SUBMIT_FINCH_ACCESS_TOKEN_START = 'userProfile/submitFinchAccessTokenStart';
export const SUBMIT_FINCH_ACCESS_TOKEN_COMPLETE = 'userProfile/submitFinchAccessTokenCompleted';
export const SUBMIT_FINCH_ACCESS_TOKEN_ERROR = 'userProfile/submitFinchAccessTokenError';

export const SET_USER_STATUS_UNAUTHORISED = 'userProfile/setUserStatusUnauthorised';

export const CLEAR_PROFILE_ERROR = 'userProfile/clearProfileError';

export const setUserStatusUnauthorised = (payload = {}) => ({
  type: SET_USER_STATUS_UNAUTHORISED,
  payload,
});

export const clearProfileError = (payload = {}) => ({
  type: CLEAR_PROFILE_ERROR,
  payload,
});

export const updateProfileInfo = (payload = {}) => ({
  type: UPDATE_PROFILE_INFO,
  payload,
});

export const requestGetUserProfile = (payload = {}) => ({
  type: REQUEST_GET_USER_PROFILE,
  payload,
});

export const submitComplaint = (payload = {}) => ({
  type: SUBMIT_COMPLAINT,
  payload,
});

export const submitFinchAccessToken = (payload = {}) => ({
  type: SUBMIT_FINCH_ACCESS_TOKEN,
  payload,
});

